import axios from "axios";
// import { setupCache } from 'axios-cache-adapter';
// import localforage from 'localforage';

// const forage = localforage.createInstance({
//   driver: [localforage.INDEXEDDB, localforage.LOCALSTORAGE, localforage.WEBSQL],
//   name: 'my-cache nba',
// });

// const cache = setupCache({
//   maxAge: 30 * 60 * 1000, //* max cache time in milisec...
//   exclude: {
//     path: [/http:\/\/167\.99\.144\.98:6301\/nba\/createbuild/],
//     methods: ['patch', 'delete', 'put'],
//   },
//   store: forage,
// });

const apiClient = axios.create({
  // baseURL: 'https://api.fantasylineups.com/',
  baseURL: "https://api.fantasylineups.com/",
  withCredentials: false,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
  // adapter: cache.adapter,
});

export default {
  getAllUsers() {
    return apiClient.get("user/getAlluser");
  },

  getUserDelete(params) {
    return apiClient.post("user/deleteUser", params);
  },

  updateUserPassword(params) {
    return apiClient.post("user/updatePassword", params);
  },

  forgetPassword(params) {
    return apiClient.post("user/forgotPassword", params);
  },

  verifyOtp(params) {
    return apiClient.post("user/verifyotp", params);
  },

  getAllTeams(params) {
    return apiClient.post("nba/getAllteams", params);
  },

  getDepthChart(params) {
    return apiClient.post("nba/getdepthchart", params);
  },

  getUpcomingGames(params) {
    return apiClient.post("nba/getupcomingmatch", params);
  },

  getInjuries(params) {
    return apiClient.post("nba/getinjuries", params);
  },

  async getAllSlate(token) {
    return await apiClient.get(`nba/getAllSlat/${token}`);
  },

  getPlayersDetails(params) {
    return apiClient.post("nba/getPlayers", params);
  },

  getTeamBuild(params) {
    return apiClient.post("nba/createbuild/", params);
  },

  getPlayerSwap(params) {
    return apiClient.post("nba/getswapplayers", params);
  },

  getTeamStack(params) {
    return apiClient.post("nba/getTeamsBySlatID", params);
  },

  playerPerTeam(TeamsDetails) {
    return apiClient.post("user/playerPerTeam", TeamsDetails);
  },

  resetPlayers(params) {
    return apiClient.post("user/resetSlat", params);
  },

  savedLineup(buildTeam) {
    return apiClient.post("user/saveLineup", buildTeam);
  },

  getAllBuild(params) {
    return apiClient.get(`user/getAllBuild/${params}`);
  },

  getLineUp(id) {
    return apiClient.get(`user/getLineup/${id}`);
  },

  setExposure(params) {
    return apiClient.post("user/setExposure", params);
  },

  unlockPlayer(params) {
    return apiClient.post("user/unlockPlayer", params);
  },

  setTopPlays(params) {
    return apiClient.post("user/setTopPlays", params);
  },

  getTopPlays(params) {
    return apiClient.post("user/getTopplays", params);
  },

  getPremiumFilters(params) {
    return apiClient.post("user/getSlatClients", params);
  },

  teamDetails(params) {
    return apiClient.post("nba/teamProfile", params);
  },

  //* player details...
  getFullStat(params) {
    return apiClient.post("nba/playerDetails", params);
  },

  // getPlayerFullStats(params) {
  //   return apiClient.post('user/getFullStats', params);
  // },

  getPlayerScoring(params) {
    return apiClient.post("user/getPlayerScore", params);
  },
  //* player details ends...

  getTopPlayers(params) {
    return apiClient.post("nba/getTopPlayers", params);
  },

  getPlayerTrend(params) {
    return apiClient.post("user/getPlayerTrends", params);
  },

  updateLineup(params) {
    return apiClient.post("user/updateLineup", params);
  },

  getNbaProps() {
    return apiClient.get("nba/nba_props");
  },

  getDailyLineups() {
    return apiClient.get("nba/starting_lineups");
  },

  getNbaNews() {
    return apiClient.get("nba/nba_news");
  },
};
